import {Alert, Form} from 'react-bootstrap'
import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Select, {components} from "react-select";
import {LabelFor} from "./LabelFor.jsx";
import {Icons} from "../Icons.jsx";
import {useDictSearch} from "../../../api/app/queries/useDictSearch.jsx";

const SelectDictSearch = (props) => {

    const Option = (internalProps) => {
        return <div>
            <components.Option {...internalProps}>
                <div className={'m-1 d-flex align-items-center line-h'}>
                    <label
                        style={{lineHeight: 1.15, fontWeight: 'normal'}}>{internalProps.data.label}</label>
                </div>
            </components.Option>
        </div>
    };

    const SingleValue = (internalProps) => {
        return (
            <components.SingleValue {...internalProps}>
                <div className={'m-1 d-flex align-items-center'}>
                    {internalProps.data.label}
                </div>
            </components.SingleValue>
        );
    };
    // noinspection DuplicatedCode
    const ClearIndicator = (props) => {
        return (
            <div>
                <components.ClearIndicator {...props}>
                    <Icons.close/>
                </components.ClearIndicator>
            </div>
        );
    };
    const DropdownIndicator = (props) => {
        return (
            <div>
                <components.DropdownIndicator {...props}>
                    <Icons.dropdown color={'#444'} size={22}/>
                </components.DropdownIndicator>
            </div>
        );
    };

    const customStyleMultiSelect = {

        menu: (provided, state) => {
            return {
                ...provided,
                borderRadius: 0,
                cursor: state.isDisabled ? 'not-allowed' : null,
            }
        },
        option: (provided) => {
            return {
                ...provided,
                minHeight: '1.8rem',
                lineHeight: .9,
                fontSize: props.size === 'sm' ? '.9rem' : null,
                fontWeight: 'normal'
            }
        },
        menuList: (provided) => {
            return {
                ...provided,
                zIndex: '100000 !important',
            }
        },

        control: (provided, state) => {
            return {
                ...provided,
                '&:hover': {
                    borderColor: null,
                },
                pointerEvents: 'auto',
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',

                backgroundColor: state.isDisabled ? '#e9ecef' : '#fff',
                minHeight: props.size === 'sm' ? 31 : null,
                borderRadius: '5px',
                border: state.isFocused && '1px solid rgb(134, 163, 208) !important',
                boxShadow: state.isFocused && 'rgba(13, 71, 161, 0.25) 0 0 0 4px !important',
                transition: state.isFocused && 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important',
                outline: state.isFocused && 'none !important',
            }
        },
        dropdownIndicator: (provided) => {
            return {
                ...provided,
                padding: '0 6px',
                marginRight: '.2rem',
                transform: 'scale(.8)',
                display: props.disabled ? 'none' : null,
            }
        }
        ,
        indicatorSeparator: (provided) => {
            return {
                ...provided,
                display: 'none',
            }
        }
        ,
        clearIndicator: (provided) => {
            return {
                ...provided,
                margin: 0,
                padding: 0,
                color: '#666',
                '&:hover': {
                    cursor: 'pointer',
                    pointerEvents: 'all'
                }
            }
        },
        placeholder: (provided) => {
            let placeholderColor = props.disabled ? '#222' : '#666'
            return {
                ...provided,
                color: placeholderColor,
                fontWeight: 'normal',
            }
        }

        ,
        input: (provided, state) => {
            return {
                ...provided,
                minHeight: props.size === 'sm' ? 24 : 33,
                padding: 0,
                margin: 1,
                lineHeight: 2,
                cursor: state.isDisabled ? 'not-allowed' : null,

            }
        },
        valueContainer: (provided) => {
            return {
                ...provided,
                margin: 0,
                marginLeft: 4,
                padding: 0,
                marginTop: 1,
                lineHeight: 2,
            }
        },
        singleValue: (provided) => {
            return {
                ...provided,
                margin: 0,
                padding: 0,
                lineHeight: 1.15,
                fontSize: props.size === 'sm' ? '.9rem' : null,
                fontWeight: 'normal',
                color: 'black',
                whiteSpace: 'break-spaces',
            }
        }
    }

    const [selected, setSelected] = useState(null);

    const data = useDictSearch(`${props.endpoint}${props.dictName ? ('/' + props.dictName) : ''}`, !props.options)

    useEffect(() => {
        if (props.value && !props.options) {
            setSelected(data?.data?.list?.map(i => ({
                value: i.id || i[props.idKey],
                label: (props.addKey ? `[${i[props.addKey]}] ` : '') + (i.nazwa || i[props.labelKey]),
            })).find(i => i.value === props.value))
        } else if (props.value && props.options) {
            setSelected(props.options
                .map(i => ({
                    value: i.id || i[props.idKey],
                    label: (props.addKey ? `[${i[props.addKey]}] ` : '') + (i.nazwa || i[props.labelKey]),
                }))

                .find(i => i.value === props.value))
        } else {
            setSelected(null)
        }
        // eslint-disable-next-line
    }, [props.value, data?.data?.list, props.options])

    return <>
        <Form.Group
            title={props.title}
            readOnly={props.readOnly}
            className={'d-flex flex-column'}>
            <div className={'align-baseline'}>
                <LabelFor label={props.label} hideLabel={props.hideLabel}  tooltipText={props.tooltipText}/>
            </div>

            <Select
                inputId={props.id || props.name || props.ariaLabel || props.label}
                title={props.title}
                isClearable
                onClear={() => setSelected(null)}
                aria-label={props.label || props.title || props.placeholder}
                disabled={props.disabled}
                noOptionsMessage={() => "Brak opcji"}
                placeholder={!props.noPlaceholder && props.placeholder || 'Wybierz opcję'}
                styles={customStyleMultiSelect}
                data-testid={props.dataTestId}
                value={selected}
                onChange={(e, {action}) => {
                    if (action === 'clear') {
                        props.onChange(null)
                        setSelected(null)
                    } else {
                        setSelected(e)
                        props.onChange(e)
                    }

                }}
                loadingMessage={() => "Wczytujemy dane"}
                options={props.options?.map(i => ({
                        value: i.id || i[props.idKey],
                        label: (props.addKey ? `[${i[props.addKey]}] ` : '') + (i.nazwa || i[props.labelKey]),
                    }))


                    || data?.data?.list?.map(i => ({
                        value: i.id || i[props.idKey],
                        label: (props.addKey ? `[${i[props.addKey]}] ` : '') + (i.nazwa || i[props.labelKey]),
                    }))}
                openMenuOnClick={!props.disabled}
                isDisabled={props.disabled}
                closeMenuOnSelect={true}
                components={{
                    Option, ClearIndicator, DropdownIndicator, SingleValue,
                }}
                onIn
                menuPlacement={"bottom"}
            />
            {props.bottomActions && props.bottomActions()}


            {props.errorText && (
                <Alert className={"p-1 w-100"} variant={"danger"}>
                    <div className={"ms-1"}> {props.errorText}</div>
                </Alert>
            )}
        </Form.Group>
    </>

}

SelectDictSearch.propTypes = {
    endpoint: PropTypes.string,
    dictName: PropTypes.string,
    label: PropTypes.string,
    kod: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.any,
    size: PropTypes.oneOf(['sm', 'lg']),
    // showId: PropTypes.bool,
    className: PropTypes.string,
    addKey: PropTypes.string,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    isFilteredDict: PropTypes.bool,
    noPlaceholder: PropTypes.bool,
    options: PropTypes.array,
    showOnlyIds: PropTypes.array,
    hideLabel: PropTypes.bool,
    id: PropTypes.string,
    sortKey: PropTypes.string,
    filter: PropTypes.arrayOf(
        PropTypes.string,
        PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
    ),  //@ [key, value] -

    bottomActions: PropTypes.func,
    errorText: PropTypes.string,
    dataTestId: PropTypes.string,
    name: PropTypes.string,
    ariaLabel: PropTypes.string,
    placeholder: PropTypes.string,
    idKey: PropTypes.string,
    labelKey: PropTypes.string,
    tooltipText: PropTypes.string,
};

export default SelectDictSearch
